import React, { useContext } from 'react';
import { Context } from '../../Context/AuthContext';

// eslint-disable-next-line import/prefer-default-export -- export nomeado, usado por 60+ telas
export function LogOutModal() {
  const { handleLogout } = useContext(Context);

  return (

    <>

      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up" />
      </a>

      {/*  <!-- Logout Modal--> */}
      <div
        className="modal fade"
        id="logoutModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
              <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">Select &quot;Logout&quot; below if you are ready to end your current session.</div>
            <div className="modal-footer">
              <button className="btn btn-secondary" type="button" data-bs-dismiss="modal">Cancel</button>
              <button className="btn btn-primary" type="button" data-bs-dismiss="modal" onClick={handleLogout}>Logout</button>
            </div>
          </div>
        </div>
      </div>

    </>

  );
}
